/**
 * 判断是不是外部资源
 */
export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
